var _style, _g, _g2, _path, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpidIdpTeamsystemidAAkvCNst(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 219.2 30",
    style: {
      enableBackground: "new 0 0 219.2 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{enable-background:new}.st1{fill:#0090d1}.st2,.st3{fill:none;stroke:#0090d1;stroke-miterlimit:10}.st3{fill:#0090d1;stroke-width:.3}.st18{fill:#2b66ae}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.9 9.2h1.8v14h-1.8v-14zM156.9 9.2c4.5 0 6.9 2.3 6.9 7 0 4.9-2.4 7-7.2 7h-3.8v-14h4.1zm-2.3 1.7v10.8h2.4c3.5 0 4.9-1.8 4.9-5.4 0-3.5-1.4-5.4-4.9-5.4h-2.4z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M147.9 9.2h1.8v14h-1.8v-14zM156.9 9.2c4.5 0 6.9 2.3 6.9 7 0 4.9-2.4 7-7.2 7h-3.8v-14h4.1zm-2.3 1.7v10.8h2.4c3.5 0 4.9-1.8 4.9-5.4 0-3.5-1.4-5.4-4.9-5.4h-2.4z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M44.9 10.9V9.1H34.4v1.8h4.3v12.4H40.6V10.9h4.2zM48.7 12.6c-2.9 0-4.7 2.2-4.7 5.5 0 3.4 1.7 5.4 4.8 5.4 1.5 0 2.8-.5 3.9-1.4h.1V22l-.7-1.2v-.1l-.1.1c-1.1.7-2 1.1-3 1.1-2.3 0-2.9-1.7-2.9-3.2H52.8v-1c0-3.4-1.4-5.1-4.1-5.1m-2.8 4.5c.1-.6.4-2.9 2.8-2.9 1.5 0 2.3 1 2.3 2.9h-5.1zM58.7 12.6c-1.4 0-2.9.6-3.9 1.5l-.1.1v.1l.8 1.1v.1h.1c.9-.7 1.7-1.1 2.9-1.1 1.3 0 2.1.8 2.1 2.1v.9c-.5-.1-1-.1-1.5-.1-4.3 0-4.8 2.3-4.8 3.3 0 1.9 1.2 3.1 3.1 3.1 1.5 0 2.6-.6 3.3-1.8l.1 1.5v.1h1.6v-7.2c.1-2.4-1.3-3.7-3.7-3.7m1.9 6.1v.3c0 1.3-1.2 2.9-2.7 2.9-1.1 0-1.7-.5-1.7-1.5 0-1.3.9-1.9 2.9-1.9.8.2 1.2.2 1.5.2M75.5 12.6c-1.5 0-2.5.8-3.2 1.6-.4-1.1-1.2-1.6-2.5-1.6-1.2 0-2.2.5-3.1 1.6l-.1-1.3v-.1H64.9v10.5H66.8v-7.5c.6-.7 1.5-1.5 2.5-1.5s1.4.6 1.4 2.1V23.3H72.6v-7.5c.6-.7 1.4-1.4 2.4-1.4s1.4.6 1.4 2V23.3H78.3V16.1c0-2.3-.9-3.5-2.8-3.5M86 15.2c-2.3-.8-3.4-1.2-3.4-2.7 0-1.3 1-2 2.6-2 1.3 0 2.5.6 3.4 1.6l.1.1.1-.1 1-1.1v-.2c-1.2-1.4-2.7-2-4.6-2-2.8 0-4.6 1.5-4.6 3.9 0 2.1 1.1 3.1 4.2 4.1 2.5.8 3.1 1.3 3.1 2.7 0 1.4-1.1 2.3-2.8 2.3-1.3 0-2.6-.6-3.9-1.8l-.1-.1-.1.1-1 1.2v.2c1.3 1.4 3.1 2.2 5 2.2 2.9 0 4.8-1.6 4.8-4.2 0-2.2-.9-3.2-3.8-4.2M97.6 12.9 95 21l-2.6-8v-.1h-2v.1L94 23.2l-.2.5c-.6 1.7-1 2-1.7 2-.6 0-1.2-.1-1.3-.2h-.1v.1l-.2 1.2v.1h.1c.6.2 1.1.2 1.8.2 2.1 0 2.5-1.1 3.4-3.9l3.6-10.4v-.1h-1.8v.2zM104.8 17.2c-1.8-.5-2.4-.8-2.4-1.7 0-.8.7-1.3 1.9-1.3 1 0 2 .4 2.8 1.2l.1.1.1-.1.8-1v-.1l-.1-.1c-1-1-2.3-1.6-3.8-1.6-2.3 0-3.7 1.2-3.7 3.1 0 1.6.9 2.5 3.3 3.1 1.8.5 2.3.8 2.3 1.7 0 .9-.8 1.4-2.1 1.4-1 0-2.1-.5-3.1-1.3l-.1-.1-.1.1-.8 1.1v.1c1 1.1 2.6 1.7 4.2 1.7 2.4 0 3.9-1.2 3.9-3.3.1-1.5-.8-2.4-3.2-3M114.1 21.8l-.1-.1c-.3.1-.5.2-.9.2-.5 0-.7-.2-.7-.8v-6.7H114.1v-1.6H112.4V9.9h-1.6v.1l-.2 2.8-1.2.3h-.1V14.4h1.3v7c0 1.4.6 2.1 1.9 2.1.6 0 1.3-.1 1.8-.3h.1v-.1l-.3-1.3zM120.1 12.6c-2.9 0-4.7 2.2-4.7 5.5 0 3.4 1.7 5.4 4.8 5.4 1.5 0 2.8-.5 3.9-1.4h.1V22l-.7-1.2v-.1l-.1.1c-1.1.7-2 1.1-3 1.1-2.3 0-2.9-1.7-2.9-3.2H124.4v-1c-.1-3.4-1.5-5.1-4.3-5.1m-2.7 4.5c.1-.6.4-2.9 2.8-2.9 1.5 0 2.3 1 2.3 2.9h-5.1zM136.9 12.6c-1.5 0-2.5.8-3.2 1.6-.4-1.1-1.2-1.6-2.5-1.6-1.2 0-2.2.5-3.1 1.6l-.1-1.3v-.1H126.3v10.5H128.2v-7.5c.6-.7 1.5-1.5 2.5-1.5s1.4.6 1.4 2.1V23.3H134v-7.5c.6-.7 1.4-1.4 2.4-1.4s1.4.6 1.4 2V23.3H139.7V16.1c0-2.3-1-3.5-2.8-3.5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "m17.1 22.8-.1.3 7.2 2.3.4-.4c.1-.2.2-.3.2-.3l-7.6-2.4c0 .1 0 .3-.1.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000041976544197139447670000002673184266222257809_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132085851851957405440000004719417871508315798_",
    gradientUnits: "userSpaceOnUse",
    x1: -558.747,
    y1: -342.695,
    x2: -558.44,
    y2: -342.695,
    gradientTransform: "matrix(25.3343 0 0 -25.3343 14172.491 -8657.987)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e62f72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#e62f72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#ec694a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ec694a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000041976544197139447670000002673184266222257809_)",
      fill: "url(#SVGID_00000132085851851957405440000004719417871508315798_)"
    },
    d: "M17 22.4h7.8v3.1H17z"
  }), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000098222717382479632330000002046751090888846485_",
    d: "m.7 10.1 8.9 1v-.9L.7 9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000171696301722496260450000001872865272929005725_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098222717382479632330000002046751090888846485_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156586922669604951060000011553940657108326565_",
    gradientUnits: "userSpaceOnUse",
    x1: -559.804,
    y1: -341.381,
    x2: -559.498,
    y2: -341.381,
    gradientTransform: "matrix(28.9794 0 0 -28.9794 16223.5 -9882.964)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#119ed9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#72bfeb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000171696301722496260450000001872865272929005725_)",
      fill: "url(#SVGID_00000156586922669604951060000011553940657108326565_)"
    },
    d: "M.7 9h8.9v2.1H.7z"
  }), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000174569951917121541660000011555776339437551504_",
    d: "M.7 16.5v.8l8.9-.8v-.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000077291166954325434090000013647867906125638569_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000174569951917121541660000011555776339437551504_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130608543508958568370000016098288047688671916_",
    gradientUnits: "userSpaceOnUse",
    x1: -559.804,
    y1: -340.868,
    x2: -559.498,
    y2: -340.868,
    gradientTransform: "matrix(28.9794 0 0 -28.9794 16223.5 -9861.614)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#119ed9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007ec2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000077291166954325434090000013647867906125638569_)",
      fill: "url(#SVGID_00000130608543508958568370000016098288047688671916_)"
    },
    d: "M.7 15.8h8.9v1.5H.7z"
  }), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000082359229655484603820000001284132348070107049_",
    d: "M1.7 24.2s.1.2.4.6l.3.3 7.6-3.2s-.1-.2-.1-.5c-.2-.3-.2-.6-.2-.6l-8 3.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000059998683262859250360000015719055639793649841_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000082359229655484603820000001284132348070107049_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178927385416486005030000003311228537523825315_",
    gradientUnits: "userSpaceOnUse",
    x1: -578.598,
    y1: -360.254,
    x2: -578.292,
    y2: -360.254,
    gradientTransform: "scale(18.9093 -18.9093) rotate(48.199 -690.387 466.169)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1b61ab"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007ec2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000059998683262859250360000015719055639793649841_)",
      fill: "url(#SVGID_00000178927385416486005030000003311228537523825315_)"
    },
    d: "m-.4 23.2 5.8-6.5 6.7 6-5.8 6.5z"
  }), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000072975142732248903570000006656384413969793447_",
    d: "M16.8 17.4s.1.4.1.6 8.1-1.2 8.1-1.2-.1-.5-.1-.7h-.1c-1 .1-8 1.3-8 1.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168797412732620182370000006499921009983264190_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000072975142732248903570000006656384413969793447_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021089873595476839540000005167017487646974343_",
    gradientUnits: "userSpaceOnUse",
    x1: -559.77,
    y1: -342.202,
    x2: -559.464,
    y2: -342.202,
    gradientTransform: "matrix(26.841 0 0 -26.841 15041.616 -9167.79)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f8b133"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.052,
    style: {
      stopColor: "#f8b133"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#ec694a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ec694a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000168797412732620182370000006499921009983264190_)",
      fill: "url(#SVGID_00000021089873595476839540000005167017487646974343_)"
    },
    d: "M16.8 16.2H25v2.1h-8.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000157299222974337175410000009919884584535411333_",
    d: "M15.9 9.6c-.1.4-.2.7-.2.7l8.6 2.3s0-.2.1-.5c0-.1.1-.2.1-.2L16.2 9s-.2.2-.3.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000129897797242192098410000001414624330946750851_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000157299222974337175410000009919884584535411333_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091012496352055563820000007678719037180975022_",
    gradientUnits: "userSpaceOnUse",
    x1: -560.664,
    y1: -341.661,
    x2: -560.358,
    y2: -341.661,
    gradientTransform: "matrix(28.4324 0 0 -28.4324 15956.749 -9703.43)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f8b133"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.162,
    style: {
      stopColor: "#f8b133"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#ffd631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd631"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000129897797242192098410000001414624330946750851_)",
      fill: "url(#SVGID_00000091012496352055563820000007678719037180975022_)"
    },
    d: "M15.7 9h8.7v3.6h-8.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000031182766530577229650000016705351448279257775_",
    d: "M7.9 2.8C3.2 2.8.7 4.7.7 8.7v.8l9.2 1.1h2.2V6.1H9.7V2.7l-1.8.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181071975454429875570000002859947784556963765_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031182766530577229650000016705351448279257775_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088130422079972732250000014320173721332849041_",
    gradientUnits: "userSpaceOnUse",
    x1: -563.573,
    y1: -337.762,
    x2: -563.267,
    y2: -337.762,
    gradientTransform: "matrix(36.9328 0 0 -36.9328 20815.027 -12467.732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#119ed9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#72bfeb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000181071975454429875570000002859947784556963765_)",
      fill: "url(#SVGID_00000088130422079972732250000014320173721332849041_)"
    },
    d: "M.7 2.8H12v7.9H.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000108279773351103307980000016546123255167231404_",
    d: "m.7 16.9 8.9-.7v-5.6h.3L.7 9.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000179647595428956816800000016588050923130517665_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000108279773351103307980000016546123255167231404_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142894694908296858480000002124561073134759060_",
    gradientUnits: "userSpaceOnUse",
    x1: -558.148,
    y1: -342.736,
    x2: -557.841,
    y2: -342.736,
    gradientTransform: "matrix(26.5555 0 0 -26.5555 14821.892 -9088.321)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#119ed9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007ec2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000179647595428956816800000016588050923130517665_)",
      fill: "url(#SVGID_00000142894694908296858480000002124561073134759060_)"
    },
    d: "M.7 9.5h9.2v7.4H.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000059267636151434387110000013736406280082608545_",
    d: "M2.1 24.8c1.4 2 3.6 3.2 6.3 3.7 0 0 5-1.2 6.5-4.3-.3.1-1 .1-1.4.1-2.3 0-3.3-1.2-3.8-2.8l-7.6 3.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000011743311057861888570000012118129199084503202_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000059267636151434387110000013736406280082608545_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000133492047903829730370000011691663333417664135_",
    gradientUnits: "userSpaceOnUse",
    x1: -543.088,
    y1: -327.978,
    x2: -542.782,
    y2: -327.978,
    gradientTransform: "scale(20.0482 -20.0482) rotate(-37.235 213.675 -971.138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1b61ab"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#164193"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000011743311057861888570000012118129199084503202_)",
      fill: "url(#SVGID_00000133492047903829730370000011691663333417664135_)"
    },
    d: "M6.8 15.2 18.3 24l-8 10.7-11.6-8.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000058572177511161166350000005623362291415015054_",
    d: "M.7 16.9v3.2c0 1.9.5 3.5 1.4 4.7l7.7-3.3c-.2-.7-.2-1.6-.2-2.4v-2.9l-8.9.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000108275689721643275330000010079006511989915288_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000058572177511161166350000005623362291415015054_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042713408021384358430000000934080722328540808_",
    gradientUnits: "userSpaceOnUse",
    x1: -578.262,
    y1: -350.098,
    x2: -577.956,
    y2: -350.098,
    gradientTransform: "scale(26.4578 -26.4578) rotate(48.2 -679.414 470.974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1b61ab"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007ec2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000108275689721643275330000010079006511989915288_)",
      fill: "url(#SVGID_00000042713408021384358430000000934080722328540808_)"
    },
    d: "m-3.5 21 8.3-9.3 9.3 8.3-8.3 9.3z"
  })), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000005957230594968058040000018289886910673517199_",
    d: "M21.4 6.1c-2.8 0-4.8 1.4-5.5 3.5l8.5 2.5c.3-1.1 1.3-1.5 2.7-1.5V6.1h-5.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106843983964405696810000003266461301598519211_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005957230594968058040000018289886910673517199_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047058161950219048000000006855432853022865537_",
    gradientUnits: "userSpaceOnUse",
    x1: -564.352,
    y1: -337.778,
    x2: -564.046,
    y2: -337.778,
    gradientTransform: "matrix(36.4954 0 0 -36.4954 20612.16 -12318.256)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f8b133"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.162,
    style: {
      stopColor: "#f8b133"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#ffd631"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd631"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000106843983964405696810000003266461301598519211_)",
      fill: "url(#SVGID_00000047058161950219048000000006855432853022865537_)"
    },
    d: "M15.9 6.1h11.2v6H15.9z"
  })), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000062883352264132124810000000262496028590534325_",
    d: "M15.8 12.8c.4 1.9.8 3.4 1.1 4.9l8.1-1.2c-.3-1.4-.6-2.7-.6-3-.1-.6-.1-1 0-1.4l-8.5-2.5c-.3 1-.4 2.1-.1 3.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000127731456843985289130000015988125174825391790_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000062883352264132124810000000262496028590534325_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177447984833154066330000016831682484104803261_",
    gradientUnits: "userSpaceOnUse",
    x1: -561.817,
    y1: -340.191,
    x2: -561.511,
    y2: -340.191,
    gradientTransform: "matrix(30.5656 0 0 -30.5656 17187.887 -10384.478)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f8b133"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.052,
    style: {
      stopColor: "#f8b133"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#ec694a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ec694a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000127731456843985289130000015988125174825391790_)",
      fill: "url(#SVGID_00000177447984833154066330000016831682484104803261_)"
    },
    d: "M15.5 9.6H25v8.1h-9.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000003808562646140379420000001602281668995939970_",
    d: "m11.4 28.4.1.3h2.8c3.9 0 8.2-.9 10.2-3.8L17 22.7c-.4 2.6-2.2 4.5-5.6 5.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047049523498837651270000014146034538676745347_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000003808562646140379420000001602281668995939970_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002373756593949233530000010647796573859801279_",
    gradientUnits: "userSpaceOnUse",
    x1: -590.079,
    y1: -346.988,
    x2: -589.773,
    y2: -346.988,
    gradientTransform: "scale(24.8717 -24.8717) rotate(73.951 -524.307 218.19)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c2006b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#e62f72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e62f72"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000047049523498837651270000014146034538676745347_)",
      fill: "url(#SVGID_00000002373756593949233530000010647796573859801279_)"
    },
    d: "m9.9 28.4 2.6-9.1 13.7 4-2.6 9z"
  })), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000172403250922139048820000012271209432173922188_",
    d: "M16.9 17.7c.2 1.2.4 2.4.4 3.8 0 .5 0 .9-.1 1.4l7.5 2.2c.7-1 1.1-2.2 1.1-3.7 0-1.1-.4-3.1-.7-4.9l-8.2 1.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000099637313568255601500000015254607653514647169_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000172403250922139048820000012271209432173922188_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000030457155148916870820000018225999514751060667_",
    gradientUnits: "userSpaceOnUse",
    x1: -563.85,
    y1: -345.461,
    x2: -563.543,
    y2: -345.461,
    gradientTransform: "scale(26.3597 -26.3597) rotate(12.295 -1881.41 2447.302)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e62f72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#e62f72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#ec694a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ec694a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000099637313568255601500000015254607653514647169_)",
      fill: "url(#SVGID_00000030457155148916870820000018225999514751060667_)"
    },
    d: "m15.1 16.9 10.2-2.2 2.2 10-10.2 2.2z"
  })), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M194.5 26.9V14.7c0-.3.1-.4.4-.4h1.5c.3 0 .5 0 .5.4.5-.2.9-.5 1.4-.6 1.9-.3 3.5.5 3.9 2.6.2 1.2.3 2.5 0 3.7-.3 1.9-1.4 2.8-3.4 2.9-.5 0-1.1 0-1.6-.1-.2 0-.4-.1-.4.3 0 1.1-.1 2.2 0 3.4h-2.3zm2.3-8v2c0 .3.1.4.3.4.4 0 .8.1 1.2 0 .8-.1 1.2-.4 1.4-1.2.2-.8.2-1.6.1-2.5-.2-1.1-.8-1.6-1.9-1.4-.3 0-.5.1-.7.2-.3.1-.4.2-.4.5v2zM218.7 16.9v5.7c0 .3-.1.5-.4.5H217c-.2 0-.5.1-.6-.2-.1-.2-.3 0-.4.1-.9.4-1.8.5-2.7.3-1.1-.2-1.8-.8-2.1-1.9-.5-1.6-.5-3.3 0-4.9.5-1.8 2-2.4 3.7-2.3.4 0 .8.1 1.1.2.4.1.5-.1.5-.4v-2.7c0-.3.1-.4.4-.4h1.6c.3 0 .4.1.4.4-.2 1.8-.2 3.7-.2 5.6zm-2.4 1.7v-1c0-1.5 0-1.5-1.6-1.5-.7 0-1.1.2-1.3.9-.4 1.1-.3 2.3 0 3.4.1.4.4.7.8.7.6 0 1.2 0 1.8-.2.2-.1.3-.2.3-.4v-1.9zM192.5 16.5c-1.2-.1-2.2-.3-3.3-.3-.7 0-1.2.2-1.2.6 0 .7.6.6 1 .7.7.2 1.5.2 2.3.5 1 .4 1.5 1 1.5 2.1 0 .8 0 1.5-.6 2.2s-1.5.9-2.4 1c-1.2.1-2.5-.1-3.7-.3-.3 0-.4-.2-.3-.4v-1.1c-.1-.5.2-.5.6-.4 1 .2 2 .2 2.9.2.7 0 1-.2 1.1-.6 0-.6-.5-.6-.9-.7-.7-.2-1.4-.2-2.1-.4-1.3-.4-1.7-1-1.8-2.2-.1-1.3.5-2.2 1.5-2.7 1.1-.5 2.2-.4 3.3-.3.6.1 1.1.2 1.7.3.2 0 .4.1.4.4-.1.3 0 .8 0 1.4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M204 16.8c0-1.5 1.1-2.5 2.6-2.4 1.4 0 2.5 1.1 2.4 2.6 0 1.5-1.1 2.5-2.6 2.5-1.4-.1-2.4-1.2-2.4-2.7z",
    style: {
      fill: "#2965ae"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M206.5 23h-2c-.5 0-.5-.2-.4-.5.1-1 .9-1.8 2.1-2 1.1-.2 2.1.3 2.6 1.3.5 1.1.4 1.3-.7 1.3-.6-.1-1.1-.1-1.6-.1z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#0e8fcf",
      strokeWidth: 2.5,
      strokeMiterlimit: 10
    },
    d: "M174.6.5v29.4"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpidIdpTeamsystemidAAkvCNst);
export default __webpack_public_path__ + "static/media/spid-idp-teamsystemid~AAkvCNst.fec3b314f848ca9965fdca47c64c8c2d.svg";
export { ForwardRef as ReactComponent };